function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5.92,
  d: "M3.19 36.78v22.71h57.62V36.78M32 3.22V39.4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.13 28.28H18.87L32 45.48l13.13-17.2z"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZG93bmxvYWQ8L3RpdGxlPjxwb2x5bGluZSBwb2ludHM9IjMuMTkgMzYuNzggMy4xOSA1OS40OSA2MC44MSA1OS40OSA2MC44MSAzNi43OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI1LjkyIi8+PGxpbmUgeDE9IjMyIiB5MT0iMy4yMiIgeDI9IjMyIiB5Mj0iMzkuNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI1LjkyIi8+PHBhdGggZD0iTTQ1LjEzLDI4LjI4SDE4Ljg3TDMyLDQ1LjQ4bDEzLjEzLTE3LjJaIi8+PC9zdmc+";
export { SvgDownload as ReactComponent };